<template>
  <div @click="$emit('click')" class="emoji-item">
    <img v-if="isWindows" :src="getEmojiImageUrl(emoji)" :alt="emoji" :class="sizeClass" />
    <span v-else :class="sizeClass">{{ emoji }}</span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NEmoji extends Vue {
  @Prop() emoji!: string
  @Prop({
    type: String,
    validator: (prop: string) => ['s', 'm', 'l'].includes(prop),
    default: 'm'
  })
  size?: String
  private baseUrl = 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/'
  private variatonSelectorCodePoint = 'fe0f'

  get sizeClass() {
    return {
      'size-s': this.size === 's',
      'size-m': this.size === 'm',
      'size-l': this.size === 'l'
    }
  }

  get isWindows() {
    return navigator.userAgent.includes('Win')
  }

  getEmojiImageUrl(emoji: string): string {
    const codePoints = Array.from(emoji).map(char => char.codePointAt(0)?.toString(16).toLowerCase() || '')

    if (codePoints.length <= 3 && codePoints[1] === this.variatonSelectorCodePoint) {
      codePoints.splice(1, 1)
    }
    const unicodeHex = codePoints.join('-')

    return `${this.baseUrl}${unicodeHex}.png`
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles' as *;

.emoji-item {
  display: flex;

  .size-s {
    width: $notch-space-4x;
    height: $notch-space-4x;
  }

  .size-m {
    width: $notch-space-4_5x;
    height: $notch-space-4_5x;
  }

  .size-l {
    width: $notch-space-6x;
    height: $notch-space-6x;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

span {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
